<template>
  <button class="color-gray-450" type="button" @click="emit('toggle-menu')">
    <svg
      class="h-6 w-6"
      :class="open ? 'hidden' : 'block'"
      stroke="currentColor"
      fill="none"
      viewBox="0 0 24 24"
    >
      <path
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="2"
        d="M4 6h16M4 12h16M4 18h16"
      />
    </svg>
    <svg
      class="h-6 w-6"
      :class="open ? 'block' : 'hidden'"
      stroke="currentColor"
      fill="none"
      viewBox="0 0 24 24"
    >
      <path
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="2"
        d="M6 18L18 6M6 6l12 12"
      />
    </svg>
  </button>
</template>

<script setup>
const { open } = defineProps({
  open: {
    type: Boolean,
    required: true,
  },
});

const emit = defineEmits(['toggle-menu']);
</script>

<style></style>
